import { CHANGE_THEME, REFRESH_THEME } from '../actions/Types'


const ThemeReducer = (state=null, action) => {
    switch (action.type){
        case CHANGE_THEME:
            return action.payload
        case REFRESH_THEME:
            return action.payload
        default:
            return state

    }

}

export default ThemeReducer